import * as types from './../constants/actionTypes';
import {GET_HISTORY, SEND_HISTORY} from './../constants/restURLs';
import {fetchApi} from './../api';
import {alertSuccess, alertFailed} from './AlertActions';
//import { alertFailed, alertSuccess } from './AlertActions';
import { showLoadingIndicator } from './loginActions';

const getHistorySuccess = (history) => {
    return {
        type: types.GET_HISTORY_SUCCESS,
        history
    }
}

const getHistoryFailed = () => {
    return {
        type: types.GET_HISTORY_FAILED
    }
}

export const getHistory = (account) => (dispatch) => {
    dispatch( showLoadingIndicator(true) );
    let lang = localStorage.getItem('lang');
    let params = `accountId= ${account}&lgeCode=${lang}`;
    let callbacks = {
        onSuccess: (response) => {
            let history = JSON.parse(response.actions);
            console.log('history',history);
            dispatch( getHistorySuccess(history) );
            dispatch( showLoadingIndicator(false) );
        },
        onFailed: (response, statusCode) => {
            dispatch( getHistoryFailed() );
            dispatch( showLoadingIndicator(false) );
        },
        onError: (error) => {
            dispatch( getHistoryFailed() );
            dispatch( showLoadingIndicator(false) );
        }
    }
    fetchApi(dispatch, GET_HISTORY, params, callbacks);
}

const sendHistorySuccessful = () =>  {
    return {
    type: types.SEND_HISTORY_SUCCESSFUL
  }
}

const sendHistoryFailed = () => {
    return {
    type: types.SEND_HISTORY_FAILED
  }
}

const showProgresHistory = () => {
    return {
        type: types.SEND_HISTORY_PROGRESS
    }
}

export const sendHistory = (accountId) => (dispatch) => {
    dispatch( showProgresHistory() );
    dispatch( showLoadingIndicator(true) );
    let lang = localStorage.getItem('lang');
    let params = `accountId=${accountId}&lgeCode=${lang}`;

    let callbacks = {
        onSuccess: (response) => {
            console.log('sendHistory Success',response);
            dispatch( sendHistorySuccessful() );
            dispatch( alertSuccess(response.message) );
            dispatch( showLoadingIndicator(false) );
        },
        onFailed: (response, statusCode) => {
            console.log('sendHistory failed',response, statusCode);
            dispatch( sendHistoryFailed() );
            dispatch( alertFailed(response.message) );
            dispatch( showLoadingIndicator(false) );
        },
        onError: (error)=> {
            console.log('sendHistory error',error);
            dispatch( sendHistoryFailed() );
            dispatch( alertFailed(error) );
            dispatch( showLoadingIndicator(false) );
        }
    }
    fetchApi(dispatch, SEND_HISTORY, params, callbacks);
}



// WEBPACK FOOTER //
// ./src/actions/historyActions.js